/*

Par kontekstiem

Saņemtie konteksti glabājas iekš authentication.u.contexts, bet, publiskākai lietošanai, 
ir arī zem $rootScope.u

1. u.contexts — visi konteksti, maps code => { code, context_type, name, params }
2. u.is — maps ar kontekstu tipiem
  if u.is.anonymous ...
  if u.is.manager ...
  if u.is.organization ...
  norāda tikai aktuālo kontekstu.

3. u.context — aktuālā konteksta kods (anonymous, manager, org-123)


ctxgo.decorator.coffee nodrošina to, ka $state.go tiek automātiski pievienots šībrīža konteksts.
 */
angular
  .module("myApp")
  .service("authentication", function ($http, $cookies, $rootScope, $state, $q, forcehttp) {
    this.u = {
      id: undefined,
      epasts: undefined,
      vards: undefined,
      uzvards: undefined,
      is_logged_in: false,
      needs_data_confirmation: false,
      needs_conflict_confirmation: false,
      contexts: [
        {
          code: "pub",
          context_type: "anonymous",
          name: "Neautorizēts lietotājs",
        },
      ],
      context: "pub",
      rights: [],
      is: {},
    }
    $rootScope.u = this.u
    this.login = (username, password) => {
      const req = {
        method: "POST",
        url: "/api/login",
        data: {
          username: username,
          password: password,
        },
      }
      this.u.is_logged_in = false
      this.promise = $http(req)
      this.promise.then((r) => {
        this.update(r.data)
        this.refresh_rights()
      })
      return this.promise
    }
    this.update = (d) => {
      this.u.id = d.id
      this.u.is_logged_in = d.is_logged_in
      this.u.epasts = d.epasts
      this.u.vards = d.vards
      this.u.uzvards = d.uzvards
      if (d.is_logged_in) {
        if (!d.ir_piekritis_apstradei && !d.contexts.find((c) => c.context_type === "expert")) {
          this.u.needs_data_confirmation = true
        } else {
          this.u.needs_data_confirmation = false
        }
        if (!d.ir_piekritis_konfidenc && !!d.contexts.find((c) => c.context_type === "expert")) {
          this.u.needs_expert_confirmation = true
        } else {
          this.u.needs_expert_confirmation = false
        }
        // console.log(JSON.stringify(d))
        // console.log(JSON.stringify(this.u))
      } else {
        this.u.needs_data_confirmation = false
        this.u.needs_expert_confirmation = false
      }
      this.u.rights = []
      return this.update_contexts(d.contexts)
    }
    this.refresh = () => {
      this.promise = forcehttp
        .get("/api/auth", true)
        .then((d) => {
          this.update(d.data)
          this.refresh_rights()
        })
        .catch(this.logout)
      return this.promise
    }
    this.refresh_rights = () =>
      $http({
        url: "/api",
      }).then((r) => {
        this.u.rights = r.data
      })
    this.logout = () => {
      $http({
        url: "/api/logout",
      })
        .then(() => {
          this.refresh()
        })
        .then(() => {
          return $state.go("app.home")
        })
    }
    this.update_contexts = (ctxs) => {
      if (ctxs.length === 0) {
        // eslint-disable-next-line no-console
        console.log("Bug: no contexts received, using anonymous")
        ctxs = [
          {
            code: "pub",
            context_type: "anonymous",
            name: "Neautorizēts lietotājs",
          },
        ]
      }

      this.u.contexts = {}
      _.each(
        _.sortBy(ctxs, (n) => n.code),
        (ctx) => {
          this.u.contexts[ctx.code] = ctx
        }
      )
      this.update_context()
    }

    this.update_context = () => {
      this.set_context($cookies.get("current_context"))
    }

    this.set_context = (code) => {
      if (this.u.contexts[this.u.context] && !this.u.contexts[code]) {
        // eslint-disable-next-line no-console
        console.log(`Ignoring attempt to set context to ${code}`)
        return
      }
      if (!code || !this.u.contexts[code] || code === "undefined") {
        code = _.first(_.keys(this.u.contexts))
      }
      this.u.is = {}
      if (this.u.contexts[code]) {
        this.u.context = code
        const ctx = this.u.contexts[code]
        this.u.is[ctx.context_type] = true
        if (ctx.params === "+admin") this.u.is.admin = true

        if (ctx.context_type.substr(0, 13) === "organization_") {
          this.u.is.organization = true
        }
        this.u.context_type = ctx.context_type
        $cookies.put("current_context", code)
        $rootScope.$broadcast("context-changed", this.u.context)
      }
    }

    this.require_context = (context_type) =>
      this.promise.then(() => {
        if (this.u.context_type === context_type) {
          return true
        }
        const c = _.find(this.u.contexts, {
          context_type: context_type,
        })
        if (c) {
          this.set_context(c.code)
          return true
        }
        const msg = `User has no access to context_type ${context_type}`
        // eslint-disable-next-line no-console
        console.log(msg)
        return $q.reject(msg)
      })

    this.when_ready = (callback) => this.promise.then(callback)

    return this
  })
